const userRoutes = {
  users: {
    path: '/users'
  }
};

export default userRoutes;
